const Notfound = () => {
    return (
        <section className="w-100 d-flex align-items-center justify-content-center">
            <img className="w-50" src="/imgs/notfound/notfound2.png" alt="Not Found" />
        </section>
    );
}

export default Notfound;